export const actionTypes = {
  INIT_CART: 'INIT_CART',
  SET_CART: 'SET_CART',
  TOGGLE_CHECK_ITEM: 'TOGGLE_CHECK_ITEM',
  TOGGLE_CHECK_ALL: 'TOGGLE_CHECK_ALL',
  CHANGE_PRODUCT_NUMBER: 'CHANGE_PRODUCT_NUMBER',
  DELETE_PRODUCTS: 'DELETE_PRODUCTS',
};